/* eslint-disable unicorn/prefer-object-from-entries */
/* eslint-disable unicorn/no-nested-ternary */
import {
  SOURCE,
  MEDIUM,
  CAMPAIGN,
  TERM,
  CONTENT,
  DCLID,
  GCLID,
  GTM_CAMPAIGN,
  GTM_CONTENT,
  GTM_MEDIUM,
  GTM_SOURCE,
  GTM_TERM,
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_MEDIUM,
  UTM_SOURCE,
  UTM_TERM,
  DIRECT,
  NOTSET,
  UTMZ,
  UTMZZ,
  UTMZZSES,
  IAID,
  CPC,
  CPM,
  GOOGLE,
  EMPTY_STRING,
  NOTPROVIDED,
  WWW,
  ORGANIC,
  REFERRAL,
  YAHOO,
  CMCMARKETS_URL
} from './cookieConstants';
import { getCookie, writeCookie, getDomain, checkCookieExists, newCookieExpirationDate, getCookieAsObj } from './cookieHelpers';
import { IKeyMap } from './cookieInterfaces';

interface Values {
  source?: string;
  medium?: string;
  term?: string;
}

const campaignParams = [SOURCE, MEDIUM, CAMPAIGN, TERM, CONTENT];
const googleParamRegex = new RegExp('((utm|gtm)_(' + campaignParams.join('|') + ')|(d|g)clid)=.*?([^&#]*|$)', 'gi');
// yahoo regex
const yahooRegex1 = /^(r\.)?search\.yahoo\.[a-z]+(\.[a-z]+)?$/i; //r.search.yahoo.com or search.yahoo.com or search.yahoo.something.domain
const yahooRegex2 = /^(?!r\.search\.yahoo\.com$)[a-z]+\.search\.yahoo\.com$/i; //anything.search.yahoo.com excluding r.search.yahoo.com
const searchEngines = {
  '360.cn': {
    p: 'q',
    n: '360.cn'
  },
  'alice.com': {
    p: 'qs',
    n: 'alice'
  },
  'alltheweb.com': {
    p: 'q',
    n: 'alltheweb'
  },
  'ask.com': {
    p: 'q',
    n: 'ask'
  },
  'altavista.com': {
    p: 'q',
    n: 'altavista'
  },
  'search.auone.jp': {
    p: 'q',
    n: 'auone.jp'
  },
  'isearch.avg.com': {
    p: 'q',
    n: 'avg'
  },
  'aol.com': {
    p: 'q',
    n: 'aol'
  },
  'baidu.com': {
    p: 'wd',
    n: 'baidu'
  },
  'bing.com': {
    p: 'q',
    n: 'bing'
  },
  'cnn.com': {
    p: 'query',
    n: 'cnn'
  },
  'daum.net': {
    p: 'q',
    n: 'daum'
  },
  'duckduckgo.com': {
    p: 'q',
    n: 'duckduckgo'
  },
  'ekolay.net': {
    p: 'q',
    n: 'ekolay'
  },
  'eniro.se': {
    p: 'search_word',
    n: 'eniro '
  },
  'naver.com': {
    p: 'query',
    n: 'naver '
  },
  'msn.com': {
    p: 'q',
    n: 'msn'
  },
  'lycos.com': {
    p: 'q',
    n: 'lycos'
  },
  'mamma.com': {
    p: 'query',
    n: 'mama'
  },
  'kvasir.no': {
    p: 'q',
    n: 'kvasir'
  },
  'mynet.com': {
    p: 'q',
    n: 'mynet'
  },
  'najdi.org.mk': {
    p: 'q',
    n: 'najdi'
  },
  'online.onetcenter.org': {
    p: 'qt',
    n: 'o*net'
  },
  'ozu.es': {
    p: 'q',
    n: 'ozu '
  },
  'pchome.com': {
    p: 'q',
    n: 'pchome'
  },
  'rambler.ru': {
    p: 'words',
    n: 'rambler'
  },
  'sesam.no': {
    p: 'q',
    n: 'sesam'
  },
  'seznam.cz': {
    p: 'q',
    n: 'seznam'
  },
  'search.com': {
    p: 'q',
    n: 'search'
  },
  'search.netscape.com': {
    p: 'query',
    n: 'netscape'
  },
  'search.virgilio.it': {
    p: 'qs',
    n: 'virgilio'
  },
  'szukacz.pl': {
    p: 'q',
    n: 'szukacz'
  },
  'terra.com': {
    p: 'query',
    n: 'terra'
  },
  'voila.fr': {
    p: 'rdata',
    n: 'voila'
  },
  'wp.pl': {
    p: 'szukaj ',
    n: 'wirtulana polska'
  },
  'yahoo.com': {
    p: 'p',
    n: 'yahoo'
  },
  'yam.com': {
    p: 'k',
    n: 'yam'
  },
  'yandex.com': {
    p: 'text',
    n: 'yandex'
  },
  'yandex.ru': {
    p: 'text',
    n: 'yandex'
  },
  google: {
    p: 'q',
    n: 'google'
  }
} as any;

const keyMap = {
  gtm_source: GTM_SOURCE,
  gtm_medium: GTM_MEDIUM,
  gtm_campaign: GTM_CAMPAIGN,
  gtm_content: GTM_CONTENT,
  gtm_term: GTM_TERM,
  utm_source: UTM_SOURCE,
  utm_medium: UTM_MEDIUM,
  utm_campaign: UTM_CAMPAIGN,
  utm_content: UTM_CONTENT,
  utm_term: UTM_TERM,
  gclid: GCLID,
  dclid: DCLID
} as IKeyMap;

const parseGoogleParams = (str: string) => {
  const gaParams = str.match(googleParamRegex);
  let paramsObj: Record<string, string> | undefined = undefined;

  if (gaParams) {
    paramsObj = gaParams.reduce<Record<string, string>>((acc, curr) => {
      const [key, value] = curr.split('=');
      acc[key] = value;
      return acc;
    }, {});
  }

  return paramsObj;
};

const yahooReferrerLogic = (values: Values, urlObj: URL) => {
  // YAHOO LOGIC
  const yahooUrl = new URL(urlObj.href);
  const urlWithoutProtocol = yahooUrl.hostname;

  if (yahooRegex1.test(urlWithoutProtocol)) {
    values.source = YAHOO;
    values.medium = ORGANIC;
  } else if (yahooRegex2.test(urlWithoutProtocol)) {
    values.source = urlObj.hostname;
    values.medium = REFERRAL;
  }
};

const parseGaReferrer = (referrer: string, referringDomain: string, thisDomain: string) => {
  if (!referrer) return;

  const urlObj = new URL(referrer);
  const values: Values = {};

  urlObj.href = referrer;

  if (urlObj.hostname.toLowerCase().includes(GOOGLE)) {
    referringDomain = GOOGLE;
  }

  if (referringDomain?.toLowerCase().startsWith(WWW)) {
    referringDomain = referringDomain.replace(new RegExp(WWW, 'i'), EMPTY_STRING);
  }

  if (searchEngines[referringDomain] == undefined) {
    if (referringDomain !== thisDomain) {
      values.source = urlObj.hostname;
      values.medium = REFERRAL;
    }

    return values;
  }

  const searchEngine = searchEngines[referringDomain];

  const termRegex = new RegExp(searchEngine.p + '=.*?([^&#]*|$)', 'gi');
  const term = urlObj.search.match(termRegex);

  values.source = searchEngine.n;
  values.medium = ORGANIC;

  values.term = (term ? term[0].split('=')[1] : EMPTY_STRING) || NOTPROVIDED;

  if (referringDomain?.toLowerCase().includes(YAHOO)) {
    yahooReferrerLogic(values, urlObj);
  }

  return values;
};

/**
 * Get the existing cookie & update the CP1 value with the curent page path
 * Only updates if __utmzz cookie already exists & page referrer is cmcmarkets.com
 */
const updateCP1Value = (location = window.location) => {
  const currentCookieValue = getCookie(UTMZZ);

  const urlPath = location.pathname;

  // Get value between "|cp1=" and closing "|" (if any) - e.g: "|cp1=/en-gb/trading-platform/|" would return "/en-gb/trading-platform"
  const currentCP1Value = currentCookieValue?.match(/\bcp1=([^|]*)/i);
  if ((currentCP1Value ?? '').length === 0) {
    return;
  }

  const value = `cp1=${currentCP1Value![1]}`;

  const updatedCookieValue = currentCookieValue?.replace(value, `cp1=${urlPath}`);
  const thisDomain = getDomain(location.hostname);
  const cookieExpiration = newCookieExpirationDate();

  // Overwrite existing cookie with same cookie values & updated CP1 value
  writeCookie(UTMZZ, updatedCookieValue!, cookieExpiration, '/', thisDomain);
};

export const generateCookie = (location = window.location, referrer = window.document.referrer) => {
  // If cookie already exists & the referrer is cmc &, don't update cookie.
  // The cookie should always update when coming from a new source/domain.
  // The CP1 cookie value should always update when the referrer is CMC
  if (checkCookieExists(UTMZZ) && getDomain(referrer) === CMCMARKETS_URL) {
    updateCP1Value(location);
    return;
  }

  let gaReferral = {
    utmcsr: DIRECT,
    utmcmd: DIRECT,
    utmccn: NOTSET
  } as any;
  const thisHostname = location.href;
  const thisDomain = getDomain(thisHostname);
  const referringDomain = getDomain(referrer);
  const cookieExpiration = newCookieExpirationDate();
  const qs = location.search?.replace('?', '');
  let gaParams = parseGoogleParams(qs + location.hash);
  let referringInfo = parseGaReferrer(referrer, referringDomain!, thisDomain!) as any;

  const storedVals = getCookie(UTMZ) || getCookie(UTMZZ);

  if (referringDomain === thisDomain) {
    gaParams = undefined;
    referringInfo = undefined;
  }

  // Check if gaParams object exists and has any of the following properties: gtm_source, gclid, dclid
  if (gaParams) {
    // Loop through all the properties of gaParams
    for (let key in gaParams) {
      // Check if the property value is not undefined
      if (gaParams[key] !== undefined) {
        // Get the corresponding key name from the keyMap object
        const keyName = keyMap[key as keyof IKeyMap];
        // Assign the property value to the gaReferral object with the key name
        gaReferral[keyName] = gaParams[key];
      }
    }

    // Check if gaParams has only gclid property and not dclid property
    if (gaParams.gclid && !gaParams.dclid) {
      // Set utmcsr and utmcmd parameters as google/cpc
      gaReferral.utmcsr = gaParams.utm_source ?? gaParams.gtm_source ?? GOOGLE;
      gaReferral.utmcmd = gaParams.utm_medium ?? gaParams.gtm_medium ?? CPC;
      // Check if gaParams has only dclid property and not gclid property
    } else if (gaParams.dclid && !gaParams.gclid) {
      // Set utmcsr and utmcmd parameters as google/cpm
      gaReferral.utmcsr = gaParams.utm_source ?? gaParams.gtm_source ?? GOOGLE;
      gaReferral.utmcmd = gaParams.utm_medium ?? gaParams.gtm_medium ?? CPM;
      // Otherwise
    } else {
      // Read the values from the utm_source and utm_medium properties and set utmcsr and utmcmd accordingly
      gaReferral.utmcsr = gaParams.utm_source ?? gaParams.gtm_source;
      gaReferral.utmcmd = gaParams.utm_medium ?? gaParams.gtm_medium;
    }
  } else if (referringInfo) {
    gaReferral.utmcsr = referringInfo.source;
    gaReferral.utmcmd = referringInfo.medium;
    if (referringInfo.term) gaReferral.utmctr = referringInfo.term;
  } else if (storedVals) {
    const raw = storedVals.split('|');

    gaReferral = raw.reduce<Record<string, string>>((acc, curr) => {
      const [keys, val] = curr.split('=');
      const key = keys.split('.').at(-1);
      acc[key!] = val;
      return acc;
    }, {});
  }

  // Add optimizely
  const optLayer = window.optLayer;
  if (optLayer !== undefined) {
    gaReferral.optCampaign = optLayer[0].campaign;
    gaReferral.optExperiment = optLayer[0].experiment;
    gaReferral.optVariation = optLayer[0].variation;
  }

  if (window.mParticle?.Identity?.getCurrentUser()) {
    const mParticleUserId = window.mParticle.Identity.getCurrentUser().getMPID();
    gaReferral.MPID = mParticleUserId;
  }

  gaReferral.cp1 = location.pathname;

  const urlSearch = location.search;
  const urlParams = new URLSearchParams(urlSearch);
  if (urlSearch) {
    const iaid = urlParams.get(IAID);
    if (iaid) {
      gaReferral.iaid = iaid;
    }
  }

  const newCookieValues = Object.keys(gaReferral)
    .filter((key) => gaReferral[key] !== undefined && gaReferral[key] !== '')
    .map((key) => `${key}=${gaReferral[key]}`);

  writeCookie(UTMZZSES, '1', cookieExpiration, '/', thisDomain);
  writeCookie(UTMZZ, newCookieValues.join('|'), cookieExpiration, '/', thisDomain);
};

export const updateUserAttributes = () => {
  const currentUser = window.mParticle.Identity.getCurrentUser();
  const cookie = getCookieAsObj('__utmzz');

  if (currentUser) {
    if (window.optLayer?.[0]?.campaign) {
      currentUser.setUserAttribute('Optimizely Campaign ID', window.optLayer?.[0]?.campaign);
    }
    if (window.optLayer?.[0]?.experiment) {
      currentUser.setUserAttribute('Optimizely Experiment Name', window.optLayer?.[0]?.experiment);
    }
    if (window.optLayer?.[0]?.variation) {
      currentUser.setUserAttribute('Optimizely Variation ID', window.optLayer?.[0]?.variation);
    }

    // if source or medium in cookie changes, set all user attributes including missing values, set as empty string
    if (cookie?.utmcsr) {
      currentUser.setUserAttribute('utm_source', cookie.utmcsr);
    } else {
      currentUser.setUserAttribute('utm_source', '');
    }

    if (cookie?.utmcmd) {
      currentUser.setUserAttribute('utm_medium', cookie.utmcmd);
    } else {
      currentUser.setUserAttribute('utm_medium', '');
    }

    if (cookie?.utmccn) {
      currentUser.setUserAttribute('utm_campaign', cookie.utmccn);
    } else {
      currentUser.setUserAttribute('utm_campaign', '');
    }

    if (cookie?.utmcct) {
      currentUser.setUserAttribute('utm_content', cookie.utmcct);
    } else {
      currentUser.setUserAttribute('utm_content', '');
    }

    if (cookie?.utmctr) {
      currentUser.setUserAttribute('utm_term', cookie.utmctr);
    } else {
      currentUser.setUserAttribute('utm_term', '');
    }

    if (cookie?.utmgclid) {
      currentUser.setUserAttribute('gclid', cookie.utmgclid);
    } else {
      currentUser.setUserAttribute('gclid', '');
    }

    if (cookie?.utmdclid) {
      currentUser.setUserAttribute('dclid', cookie.utmdclid);
    } else {
      currentUser.setUserAttribute('dclid', '');
    }
  }
};
